import { DisplayPosition } from '@/common/manager/position/display-position';
import { handleRequestParams, handleResultProcessFunc, } from '@/common/util/request';
import { getRealRequestUrl, setAdvancedConfigToProps, } from '@/common/util/util';
import { ImageUploadCom } from '@/common/manager/filter-item/components/image-upload';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'OSSImageUpload',
    component: ImageUploadCom,
    formComponent: ImageUploadCom,
    formItemBeforeHandler: (formItem, config) => {
        const { state, formValue, urlParams, formProps } = config;
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                const { uploadProps } = componentProps;
                if (componentProps.requestConfig) {
                    const { method, serviceType, params, resultProcessFunc } = componentProps.requestConfig;
                    const url = getRealRequestUrl({
                        requestConfig: componentProps.requestConfig,
                        state,
                    });
                    if (url) {
                        const requestConfig = { url };
                        if (serviceType === 'mokelay') {
                            requestConfig.method = 'post';
                        }
                        else if (method) {
                            requestConfig.method = method;
                        }
                        requestConfig.formatParam = (oldParams) => {
                            const realParams = handleRequestParams(params, {
                                urlParamsDataSource: urlParams,
                                recordDataSource: formValue,
                                state,
                            });
                            return {
                                ...oldParams,
                                ...realParams,
                            };
                        };
                        if (typeof resultProcessFunc === 'function') {
                            requestConfig.formatResult = handleResultProcessFunc(componentProps.requestConfig);
                        }
                        componentProps.requestConfig = requestConfig;
                    }
                }
                setAdvancedConfigToProps(componentProps);
                formItem['x-component-props'] = {
                    _dataSourceName: formProps?._dataSourceName,
                    ...componentProps,
                    ...uploadProps,
                };
            }
        }
    },
};
